/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 13 2025
 * Modified By: jim Li
 */

export default {
  Tag_Common: {
    Shi: '是',
    Fou: '否',
    QiYon: '啟用',
    TingYon: '停用',
    Fu: '複',
    Dan: '單',
    Nong: '濃',
    DaiRu: '帶入',
    Tian: '天',
    XiaoShi: '小時',
    FenZhong: '分鐘',
    FenZhong_10: '10分鐘',
    FenZhong_15: '15分鐘',
    FenZhong_20: '20分鐘',
    FenZhong_30: '30分鐘',
    FenZhong_60: '60分鐘',
    XuanZe: '選擇',
    Yi: '一',
    Er: '二',
    San: '三',
    Si: '四',
    Wu: '五',
    Liu: '六',
    Ri: '日',
    You: '有',
    Wu_Y: '無',
    Zhou_Yi: '週一',
    Zhou_Er: '週二',
    Zhou_San: '週三',
    Zhou_Si: '週四',
    Zhou_Wu: '週五',
    Zhou_Liu: '週六',
    Zhou_Ri: '週日',
    AR: '領養證明書',
    BC: '香港出生證明書',
    CD: '領事團身份證',
    DI: '香港特別行政區簽證身份書',
    EC: '豁免證明書 (或稱豁免登記證明書)',
    ED: '電子醫療紀錄文件',
    ID: '香港身份證',
    MD: '澳門身份證',
    OC: '中華人民共和國發出之其他旅遊證件',
    OP: '其他國家 / 地區發出之旅遊證件',
    OW: '單程證',
    RE: '擔保書 (行街紙)',
    RP: '香港特別行政區回港證',
    TW: '雙程證',
    You_Zhi: '由',
    Zhi_You: '至',
    You_KuCun: '有庫存',
    Wu_KuCun: '無庫存',
    GongKai: '公開',
    Fei_GongKai: '非公開',
    GongYong: '公用',
    QuanLiang_PanDian: '全量盤點',
    BuFen_PanDian: '部分盤點',
    Fan: '反',
    Wei: '畏',
    Tong_DianHua: '同電話',
    Tong_Ming: '同名',
    Tong_ZhengJian: '同證件',
  },
}
